import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { transferRepeatGameToWallet } from "../../../api/postApi";
import { Button } from "semantic-ui-react";
import { FaHandHoldingUsd } from "react-icons/fa";
import { globalTrigger, notice } from "../../../redux/action/action";
import { useTranslation } from "react-i18next";
import CommonPopModal from "../../../components/Common/commonPopModal";
import CommonConfirmModal from "../../../components/Modal/commonConfirmModal";

const OneClickTransfer = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`pointQuery.${key}`);
  const i18n_backendRes = (key, props) =>
    t(`backend_response.${key}`, { ...props });

  const isTransferWallet = useSelector((state) => state.isTransferWallet);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const dispatch = useDispatch();
  const { allGamePlatform } = isHandleAllGame || {};

  const [buttonLoading, setButtonLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const splitString = (string) => {
    if (string === "") return [];
    const array = string.split("-");
    const findPlatform = allGamePlatform?.find(
      (item) => item.platform === array[0]
    );
    return {
      platform: findPlatform?.platformUid,
      platformMode: findPlatform?.platformMode,
      transferWalletType: findPlatform?.platform + (array[1] || ""),
      exchangeRate: findPlatform?.exchangeRate,
    };
  };

  const filterBalanceWallet = useMemo(() => {
    const list = Object.keys(isTransferWallet || {})
      ?.filter((item) => isTransferWallet?.[item] > 1) // 過濾掉錢包餘額<1的
      ?.map((item) => {
        if (isTransferWallet?.[item] > 0) {
          return item;
        }
      })
      ?.filter((item) => {
        const paymentToObject = splitString(item);
        const rate = parseInt(paymentToObject?.exchangeRate);
        const amounts = () => {
          if (rate == 1) {
            return Math.floor(isTransferWallet?.[item] / 1000) * 1000;
          } else if (rate == 100) {
            return Math.floor(isTransferWallet?.[item] / 100) * 100;
          } else if (rate == 1000) {
            return Math.floor(isTransferWallet?.[item] / 1) * 1;
          }
        };
        return item && amounts() > 0;
      });

    return list;
  }, [isTransferWallet]);

  const handleGetAllTransfer = () => {
    setButtonLoading(true);
    if (filterBalanceWallet?.length === 0) {
      dispatch(notice(i18n("TransferFail"), "error"));
      setButtonLoading(false);
      setOpenModal(false);
      return;
    }
    Promise.all(
      filterBalanceWallet?.map((item) => {
        const paymentToObject = splitString(item);
        const rate = parseInt(paymentToObject?.exchangeRate);
        const amounts = () => {
          if (rate == 1) {
            return Math.floor(isTransferWallet?.[item] / 1000) * 1000;
          } else if (rate == 100) {
            return Math.floor(isTransferWallet?.[item] / 100) * 100;
          } else if (rate == 1000) {
            return Math.floor(isTransferWallet?.[item] / 1) * 1;
          }
        };

        return transferRepeatGameToWallet({
          platformUid: paymentToObject.platform,
          platformType: paymentToObject.transferWalletType,
          //計算withdrawAmount並且用Math.floor無條件捨去小數
          withdrawAmount: amounts(),
        });
      })
    )
      .then((results) => {
        dispatch(notice(i18n_backendRes("TransferSuccess"), "success"));
        dispatch(globalTrigger());
        dispatch({ type: "GET_BALANCE" });
      })
      .finally(() => {
        setButtonLoading(false);
        setOpenModal(false);
      });
  };

  return (
    <>
      <Button
        size="mini"
        color="yellow"
        onClick={() => {
          setOpenModal(true);
        }}
        loading={buttonLoading}
        disabled={filterBalanceWallet.length === 0 || buttonLoading}
        type="button"
        className="!text-white !flex items-center gap-[5px] !rounded-full"
      >
        <FaHandHoldingUsd className="text-lg" />
        <span>{i18n("oneClick")}</span>
      </Button>
      {openModal && (
        <CommonConfirmModal
          modalProps={{
            title: i18n("oneClickTransfer"),
            okButtonText: i18n("confirm"),
            buttonLoading: buttonLoading,
            content: (
              <>
                <span>{i18n("areYouSure")}</span>
                <p className="text-red-500 text-sm">{i18n("passion")}</p>
              </>
            ),
            cancelButtonText: i18n("cancel"),
          }}
          onConfirm={() => {
            handleGetAllTransfer();
          }}
          modalOpen={openModal}
          size="mini"
          setModalOpen={setOpenModal}
        />
      )}
    </>
  );
};

export default OneClickTransfer;
